import React from 'react';

import * as _Signature from '../common/Signature.jsx';

function Signature(props) {
    const data = props.data || {};
    let statusIncluded = false;
    if (props.config && props.config.config) {
        let blockProps = {};
        if (props.config.config.Block) {
            blockProps = props.config.config.Block;
            switch (data.Status) {
                case 1:
                    statusIncluded = blockProps.open;
                    break;
                case 2:
                    statusIncluded = blockProps.approval;
                    break;
                case 3:
                    statusIncluded = blockProps.closed;
                    break;
                case 4:
                    statusIncluded = blockProps.declined;
                    break;
            }
        }
    }
    if (!props.builder && !statusIncluded) {
        return null;
    }
    return <_Signature.Component {...props} />
}

const TypeConfig = {
    panel: {
        block: () => {
            const blockConfig = _Signature.TypeConfig.panel.block();
            const group = blockConfig.group;
            blockConfig.options.splice(2, 0,
                {
                    fullWidth: true,
                    group,
                    type: 'info',
                    value: 'Show Signature For Status:'
                },
                {
                    display: 'Open',
                    group,
                    name: 'open',
                    type: 'checkbox',
                    value: false
                },
                {
                    display: 'On Approval',
                    group,
                    name: 'approval',
                    type: 'checkbox',
                    value: true
                },
                {
                    display: 'Closed',
                    group,
                    name: 'closed',
                    type: 'checkbox',
                    value: false
                },
                {
                    display: 'Declined',
                    group,
                    name: 'declined',
                    type: 'checkbox',
                    value: false
                }
            );
            return blockConfig;
        },
        description: _Signature.TypeConfig.panel.description,
        label: _Signature.TypeConfig.panel.label,
        style: _Signature.TypeConfig.panel.style,
        value: _Signature.TypeConfig.panel.value
    }
}

export {
    Signature as Component,
    TypeConfig
};